module.exports = __webpack_public_path__ + "img/tipdow.d248ba95.png";